import styled from "@emotion/styled";
import { theme } from "@styles/theme";
const { lg } = theme.breakpoints;
export const Container = styled.div`
  background-color: #90d1f4;
  @media (max-width: ${lg}) {
    display: none;
  }
`;
export const Img = styled.img`
  width: 100%;
`;
